// App entry point
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Remove console logs in production for cleaner output
if (import.meta.env.PROD) {
  console.log = () => {};
  console.debug = () => {};
  // Keep console.warn and console.error for debugging production issues
}

createRoot(document.getElementById("root")!).render(<App />);
